var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFondoEmpanandas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 271,
    viewBox: "0 0 311 271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9906 48.2199C104.217 -13.6922 198.09 -16.2901 261.326 42.1906C265.027 45.5975 268.213 49.2738 270.787 52.2395C271.693 53.2934 272.527 54.2247 273.213 55.009L273.556 55.3528C324.855 117.927 322.429 205.157 267.699 262.829C256.767 274.349 247.159 271.114 240.909 266.188C238.825 266.065 236.644 266.04 234.365 266.016C226.62 265.918 217.869 265.795 210.443 261.604C204.242 258.099 200.639 252.045 197.477 246.727C195.369 243.197 193.384 239.839 191.154 238.099C182.453 231.212 173.972 236.653 169.683 240.501C163.801 245.795 154.56 251.653 142.06 241.702C135.491 236.457 128.825 234.398 123.31 235.844C117.771 237.315 112.942 242.486 109.781 250.354C105.614 260.746 99.0452 264.815 87.8197 264.03C81.7413 263.589 74.7559 264.937 69.6088 267.535C59.4126 272.731 51.2993 271.579 43.5297 263.81L43.6039 263.785C43.3343 263.516 43.0884 263.271 42.8187 263.001C-14.3384 202.462 -14.2646 106.112 42.9906 48.2199Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoEmpanandas);
export default __webpack_public_path__ + "static/media/fondo_empanandas.19d50cc16a2a003be8475ef8fb5a99ab.svg";
export { ForwardRef as ReactComponent };